import { render, staticRenderFns } from "./OResellerBadge.vue?vue&type=template&id=25fa3b83&"
import script from "./OResellerBadge.vue?vue&type=script&lang=js&"
export * from "./OResellerBadge.vue?vue&type=script&lang=js&"
import style0 from "./OResellerBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports